import { atomWithStorage } from 'jotai/utils'

export const roleAtom = atomWithStorage('role', '')
